import script from "./POSMain.vue?vue&type=script&setup=true&lang=ts"
export * from "./POSMain.vue?vue&type=script&setup=true&lang=ts"

import "./POSMain.vue?vue&type=style&index=0&id=3be68c49&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3be68c49"]])

export default __exports__